import React from "react"
import {createTheme} from '@mui/material/styles';
const theme = createTheme({
    palette: {
        type: 'light',
        background: {
            default: 'var(--background-color)'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1280,
            xl: 1536,
        },
    },
    components: {
        MuiChip: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: '#303543',
                    color: 'white'
                },
                colorSecondary: {
                    backgroundColor: '#008eba',
                    color: 'white'
                },
            },
        },
    },
});

export default theme;